import EditIcon from "components/icon/EditIcon";
import React from "react";
import ProhibitionForm from "./ProhabitionForm";
import { AssetReferralActionStatusEnum, ProhibitionRequest } from "types";

interface ProhibitionSectionProps {
  isEditMode: boolean;
  isAssetRegistrar: boolean;
  referral?: any;
  prohibitionFormData: any;
  isEditingProhibition: boolean;
  showProhibitionForm: boolean;
  hasProhibitionData: boolean;
  hasCourtData: boolean;
  onProhibitionChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onProhibitionSubmit: (e: React.FormEvent) => void;
  onProhibitionEditClick: () => void;
  onCancelProhibitionEdit: () => void;
  onAddProhibitionDetails: () => void;
  onForwardToCoordinator: () => void;
  onOpenCourtPopup: () => void;
  prohibitionData: ProhibitionRequest;
  setProhibitionDataState: React.Dispatch<
    React.SetStateAction<ProhibitionRequest | null>
  >;
}

export const ProhibitionSection: React.FC<ProhibitionSectionProps> = ({
  isEditMode,
  isAssetRegistrar,
  referral,
  prohibitionFormData,
  hasProhibitionData,
  hasCourtData,
  onProhibitionChange,
  onProhibitionSubmit,
  onProhibitionEditClick,
  onCancelProhibitionEdit,
  onAddProhibitionDetails,
  onOpenCourtPopup,
  isEditingProhibition,
  showProhibitionForm,
  prohibitionData,
  setProhibitionDataState,
}) => {
  // Early return if conditions aren't met
  if (
    !isEditMode ||
    !isAssetRegistrar ||
    prohibitionData?.status !==
      AssetReferralActionStatusEnum.PROHIBITION_REQUEST_APPROVED
  ) {
    return null;
  }

  const shouldShowForm = !hasProhibitionData || isEditingProhibition;

  return (
    <div className="">
      <div className="bg-white shadow-md rounded-lg p-6 mt-4">
        <div className="flex justify-between items-center">
          <h3 className="text-base font-semibold mb-4">
            Prohibition Information
          </h3>
          {hasProhibitionData && !isEditingProhibition && (
            <button
              type="button"
              onClick={onProhibitionEditClick}
              className="flex items-center gap-2 px-4 py-2 text-black rounded-lg transition-colors"
            >
              <EditIcon />
              Edit
            </button>
          )}
        </div>

        {shouldShowForm && (
          <ProhibitionForm
            prohibitionFormData={prohibitionFormData}
            onProhibitionChange={onProhibitionChange}
            onProhibitionSubmit={onProhibitionSubmit}
            isEditingProhibition={isEditingProhibition}
            onCancel={onCancelProhibitionEdit}
            setProhibitionDataState={setProhibitionDataState}
          />
        )}
      </div>
    </div>
  );
};
